export const TICK_MS = 30000;
const CAL_LINE_CLASS = "hora-now-line";
const LIST_LINE_CLASS = "hora-agenda-list__now-line";
const LIST_SECTION_SELECTOR = ".hora-agenda-list__section[data-start-min]";
const LIST_ACTIVE_PANEL_SELECTOR = ".hora-agenda-list__panel:not([hidden])";
const PANEL_CHANGE_EVENT = "hora:agenda-list:panel-tab-change";
export function todayInTz(tz) {
    try {
        return new Intl.DateTimeFormat("en-CA", { timeZone: tz }).format(new Date());
    }
    catch (_a) {
        return "";
    }
}
export function minutesNowInTz(tz, offsetMs) {
    const now = new Date(Date.now() + offsetMs);
    try {
        const parts = new Intl.DateTimeFormat("en-GB", {
            timeZone: tz,
            hour: "2-digit",
            minute: "2-digit",
            hour12: false,
        }).formatToParts(now);
        let h = 0;
        let m = 0;
        for (const p of parts) {
            if (p.type === "hour")
                h = Number(p.value);
            else if (p.type === "minute")
                m = Number(p.value);
        }
        return h * 60 + m;
    }
    catch (_a) {
        return now.getHours() * 60 + now.getMinutes();
    }
}
export function clockOffset(serverNow) {
    if (!serverNow)
        return 0;
    const parsed = Date.parse(serverNow);
    if (Number.isNaN(parsed))
        return 0;
    return parsed - Date.now();
}
function mountCalendarLine(opts) {
    var _a;
    if (opts.rangeStartMin === undefined || opts.ppm === undefined) {
        return () => { };
    }
    const offsetMs = clockOffset((_a = opts.serverNow) !== null && _a !== void 0 ? _a : null);
    const line = document.createElement("div");
    line.className = CAL_LINE_CLASS;
    line.setAttribute("aria-hidden", "true");
    opts.container.appendChild(line);
    const rangeStart = opts.rangeStartMin;
    const ppm = opts.ppm;
    const rangeEnd = opts.rangeEndMin !== undefined
        ? opts.rangeEndMin
        : Number(opts.container.getAttribute("data-range-end-min")) ||
            24 * 60;
    function update() {
        const mins = minutesNowInTz(opts.tz, offsetMs);
        const top = (mins - rangeStart) * ppm;
        line.style.setProperty("--hora-now-top", `${Math.max(0, top)}px`);
        const inRange = mins >= rangeStart && mins <= rangeEnd;
        line.style.display = inRange ? "" : "none";
    }
    update();
    const timer = window.setInterval(update, TICK_MS);
    return () => {
        window.clearInterval(timer);
        if (line.parentElement) {
            line.parentElement.removeChild(line);
        }
    };
}
function findActiveListPanel(container) {
    var _a;
    return ((_a = container.querySelector(LIST_ACTIVE_PANEL_SELECTOR)) !== null && _a !== void 0 ? _a : container);
}
function sectionStartMin(el) {
    const eff = el.getAttribute("data-effective-start-min");
    if (eff !== null && eff !== "") {
        const n = Number(eff);
        if (Number.isFinite(n))
            return n;
    }
    const base = el.getAttribute("data-start-min");
    return Number(base !== null && base !== void 0 ? base : "0") || 0;
}
function placeListLine(line, container, tz, offsetMs) {
    const panel = findActiveListPanel(container);
    const sections = Array.from(panel.querySelectorAll(LIST_SECTION_SELECTOR));
    if (line.parentElement) {
        line.parentElement.removeChild(line);
    }
    if (sections.length === 0) {
        panel.appendChild(line);
        return;
    }
    const mins = minutesNowInTz(tz, offsetMs);
    const firstAfter = sections.find((s) => sectionStartMin(s) > mins);
    if (firstAfter) {
        const row = firstAfter.closest(".hora-agenda-list__row");
        if (row && row.parentElement) {
            row.parentElement.insertBefore(line, row);
            return;
        }
    }
    const lastRow = sections[sections.length - 1]
        .closest(".hora-agenda-list__row");
    if (lastRow && lastRow.parentElement) {
        lastRow.parentElement.insertBefore(line, lastRow.nextSibling);
    }
}
/**
 * Re-place an already-mounted list now-line. Use after live-state poll
 * updates the `data-effective-start-min` attributes on section rows so the
 * line lands in the right slot relative to the freshly-broadcast times.
 */
export function repositionListNowLine(container, tz, serverNow) {
    const line = container.querySelector("." + LIST_LINE_CLASS);
    if (!line)
        return;
    const offsetMs = clockOffset(serverNow !== null && serverNow !== void 0 ? serverNow : null);
    placeListLine(line, container, tz, offsetMs);
}
function mountListLine(opts) {
    var _a;
    const offsetMs = clockOffset((_a = opts.serverNow) !== null && _a !== void 0 ? _a : null);
    const line = document.createElement("div");
    line.className = LIST_LINE_CLASS;
    line.setAttribute("aria-hidden", "true");
    const update = () => placeListLine(line, opts.container, opts.tz, offsetMs);
    update();
    const timer = window.setInterval(update, TICK_MS);
    // Re-place when the user switches inner panel tabs (the visible panel
    // changes; the line must follow into the new tabpanel).
    const onPanelChange = () => update();
    opts.container.addEventListener(PANEL_CHANGE_EVENT, onPanelChange);
    return () => {
        window.clearInterval(timer);
        opts.container.removeEventListener(PANEL_CHANGE_EVENT, onPanelChange);
        if (line.parentElement) {
            line.parentElement.removeChild(line);
        }
    };
}
export function mountNowLine(opts) {
    if (!opts.agendaDate || !opts.tz)
        return () => { };
    if (opts.agendaDate !== todayInTz(opts.tz))
        return () => { };
    if (opts.view === "calendar") {
        return mountCalendarLine(opts);
    }
    return mountListLine(opts);
}
